import { createCustomEnum } from "./customEnum";

const AutoBoardingResultTypes = createCustomEnum({
	Success: {
		value: "succeeded",
		name: "auto_boarding_success",
		displayName: "Success",
	},
	Failed: {
		value: "failed",
		name: "auto_boarding_failed",
		displayName: "Failed",
	},
});

export default AutoBoardingResultTypes;
